var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardCashBalance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.59 16.9V22.05C28.59 25.13 26.83 26.45 24.19 26.45H15.4C14.95 26.45 14.52 26.41 14.12 26.32C13.87 26.28 13.63 26.21 13.41 26.13C11.91 25.57 11 24.27 11 22.05V16.9C11 13.82 12.76 12.5 15.4 12.5H24.19C26.43 12.5 28.04 13.45 28.47 15.62C28.54 16.02 28.59 16.43 28.59 16.9Z",
    stroke: "#373737",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5911 19.9001V25.0501C31.5911 28.1301 29.8311 29.4501 27.1911 29.4501H18.4011C17.6611 29.4501 16.9911 29.3501 16.4111 29.1301C15.2211 28.6901 14.4111 27.7801 14.1211 26.3201C14.5211 26.4101 14.9511 26.4501 15.4011 26.4501H24.1911C26.8311 26.4501 28.5911 25.1301 28.5911 22.0501V16.9001C28.5911 16.4301 28.5511 16.0101 28.4711 15.6201C30.3711 16.0201 31.5911 17.3601 31.5911 19.9001Z",
    stroke: "#373737",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7885 22.1199C21.2465 22.1199 22.4285 20.9379 22.4285 19.4799C22.4285 18.0218 21.2465 16.8398 19.7885 16.8398C18.3304 16.8398 17.1484 18.0218 17.1484 19.4799C17.1484 20.9379 18.3304 22.1199 19.7885 22.1199Z",
    stroke: "#373737",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0701 17.2803V21.6803",
    stroke: "#373737",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5117 17.2803V21.6803",
    stroke: "#373737",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardCashBalance);
export default __webpack_public_path__ + "static/media/dashboard-cash-balance.0e776dd2d69f31e5f49040df071a2cac.svg";
export { ForwardRef as ReactComponent };